import { ResponsiveGridProps } from '@cbhq/cds-common';
import { Grid, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3 } from '@cbhq/cds-web/typography';

import { useCardProducts } from ':cloud/hooks/useCardProducts';
import { useGetUser } from ':cloud/queries/UserQueries/useGetUser';
import { ProductItem } from ':cloud/types/ts_types';
import { Layout } from ':cloud/widgets/layout';
import { MAIN_CONTAINER_MIN_WIDTH } from ':cloud/widgets/product/constants';
import { NewProjectCard } from ':cloud/widgets/projects/NewProjectCard';
import { EmptyChart } from ':cloud/widgets/sharedcomponents/EmptyChart';
import { ResourceSection } from ':cloud/widgets/waasProjects/ResourceSection';

const newProjectGridConfig: ResponsiveGridProps = {
  tablet: {
    columns: 2,
  },
  desktop: {
    columns: 3,
  },
};

export function AllProjects() {
  const {
    user: { isOwnerOrAdmin },
  } = useGetUser();
  const filteredProducts = useCardProducts();
  return (
    <Layout>
      <Layout.MainContainer fullWidth minWidth={MAIN_CONTAINER_MIN_WIDTH} spacingHorizontal={0}>
        <VStack gap={5} spacingBottom={8}>
          {isOwnerOrAdmin ? (
            <VStack spacingHorizontal={7} spacingBottom={4}>
              <TextTitle3 as="h1" spacingBottom={5}>
                Select a service
              </TextTitle3>
              <Grid columns={3} gap={3} responsiveConfig={newProjectGridConfig}>
                {filteredProducts.map((card: ProductItem) => (
                  <NewProjectCard key={card.title} {...card} />
                ))}
              </Grid>
            </VStack>
          ) : null}

          <VStack spacingHorizontal={7} borderedTop spacingVertical={6}>
            <VStack height={375}>
              <VStack gap={2} justifyContent="space-between">
                <TextTitle3 as="h3">Total API requests</TextTitle3>
                <TextTitle3 as="h3">--</TextTitle3>
                <VStack height={300}>
                  <EmptyChart chartType="bar" />
                </VStack>
              </VStack>
            </VStack>
          </VStack>

          <VStack spacingHorizontal={7} borderedTop spacingVertical={6}>
            <ResourceSection />
          </VStack>
        </VStack>
      </Layout.MainContainer>
    </Layout>
  );
}
